















































































































































































import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { useAdgroupAgeOptions } from '@tt4b/ttam-hooks';
import { ref, defineComponent, PropType, toRefs, watch } from '@vue/composition-api';
import { cloneDeep } from 'lodash-es';
import { i18n } from './../../../i18n';
import TtamAdGroupName from '@/components/adgroup/ad-group-name/ad-group-name/index.vue';
import TtamGender from '@/components/adgroup/gender/gender/index.vue';
import TtamAge from '@/components/adgroup/age/age/index.vue';
import TtamOperatingSystem from '@/components/adgroup/operating-system/operating-system/index.vue';
import TtamNetwork from '@/components/adgroup/network/network/index.vue';
import { usePropsModalTitle, usePropsEditorEnable } from './hooks';
import { getFieldFromGroupData, allSameFiled, isSameContent, uniqueBatchField } from './utils';
import { useIsSelectedIndustryType } from './../../adgroup/age/hooks';
import { useGenderOPtions } from './../../adgroup/gender/hooks';
import { usePlatformOPtions } from './../../adgroup/operating-system/hooks';
import { useNetworkOptions } from './../../adgroup/network/hooks';
import { usePlatformIs } from './../../../hooks/creation/adgroup/usePlatformIs/index';

const name = 'ttam-batch-setting-modal';
export default defineComponent({
  name: 'TtamCopyBatchSettingModal',
  components: {
    TtamAdGroupName,
    TtamGender,
    TtamAge,
    TtamOperatingSystem,
    TtamNetwork,
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
    fields: {
      type: Array as PropType<(keyof AdgroupFormData)[]>,
      default: () => [],
    },
    label: {
      type: String,
      default: i18n.t('adgroup_name'),
    },
    width: {
      type: String,
      default: '840px',
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    batchFormData: {
      type: Array as PropType<Partial<AdgroupFormData>[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    // const { updateCopyData } = useAdgroupBatchEdit()
    const { visible, campaignData, label, batchFormData, adgroupData, fields } = toRefs(props);
    const { modalTitle } = usePropsModalTitle({ label, batchFormData });
    const { isEditorEnable } = usePropsEditorEnable({ fields, adgroupData });
    // 初始值
    const baseFieldCurrent = ref<Partial<AdgroupFormData>>(getFieldFromGroupData(fields.value, adgroupData.value));
    const batchFormCurrent = ref<Partial<AdgroupFormData>[]>(cloneDeep(props.batchFormData));

    const changeBatchFormByBase = () => {
      let batchData = [...batchFormCurrent.value];
      batchData = batchData.map(item => {
        const value = {
          ...item,
          ...baseFieldCurrent.value,
        };
        if (props.fields.includes('name')) {
          value.name = `${value.name}-${value.num}`;
        }
        return value;
      });
      return batchData;
    };
    const handleApplyAll = () => {
      batchFormCurrent.value = changeBatchFormByBase();
    };
    const handleClose = () => {
      emit('close');
    };
    /*
      将编辑的内容提交到表单，其中baseFieldCurrent提交到adgroupData，batchFormCurrent提交到batchFormData
      1. 当所有batch项都一致，但是与基准值不一样时，修改基准值为batch一致的值，apply后页面也显示该值。
      2. 当batch项不是全部一致时，apply后页面显示mixed value。
      3. 应该在modal内就不允许name值全部一致
    */
    const handleApply = () => {
      for (let field of props.fields) {
        const firstFieldBatchItem = batchFormCurrent.value?.[0]?.[field];
        const baseFiledTempValue = baseFieldCurrent.value?.[field];
        const allSame = allSameFiled(batchFormCurrent.value, field, firstFieldBatchItem);
        const allDifferent = uniqueBatchField(batchFormCurrent.value, field);
        if (!allDifferent) {
          if (field === 'name') {
            alert('请保证AdGroup Name值唯一');
            return;
          }
          if (allSame && !isSameContent(firstFieldBatchItem, baseFiledTempValue)) {
            baseFieldCurrent.value = {
              ...baseFieldCurrent.value,
              [field]: firstFieldBatchItem,
            };
          }
        }
      }
      emit('adgroupDataChange', { ...baseFieldCurrent.value });
      emit('copyDataChange', batchFormCurrent.value);
      handleClose();
    };
    const handleItemValueChange = (key, value) => {
      baseFieldCurrent.value = {
        ...baseFieldCurrent.value,
        [key]: value,
      };
    };
    const handleBatchItemChange = (key, value, index) => {
      const temp = cloneDeep(batchFormCurrent.value);
      temp[index] = {
        ...batchFormCurrent.value[index],
        [key]: value,
      };
      batchFormCurrent.value = temp;
    };

    const { isSelectedIndustryType } = useIsSelectedIndustryType({ campaignData });
    const { ageOptions } = useAdgroupAgeOptions({ campaignFormData: campaignData, adgroupFormData: adgroupData });
    const { genderOptions } = useGenderOPtions();
    const { iOSPlatformDisabled } = usePlatformIs({
      adgroupData,
      campaignData,
    });
    const { platformOptions } = usePlatformOPtions({ iOSPlatformDisabled });
    const { networkOptions } = useNetworkOptions();

    watch([visible], ([newVal]) => {
      if (newVal) {
        batchFormCurrent.value = cloneDeep(props.batchFormData);
        /*
          两种情况 baseFieldCurrent 的值与 adgroupData 中的会出现不一致
          1.存在 baseFieldCurrent 值选了但是直接 close modal 没有 apply 的情况；
          2.存在联动导致 adgroupData 对应字段变了的情况（osv 变 platform 跟着变）；
          所以 baseFieldCurrent 的值在此处始终以 adgroupData 重新赋值

          batchFormCurrent 中的值以 batchFormData 的值为准，如果 batchFormData 中没有当前 fields 字段，
          需要通过 adgroupData 构建出初始值用于数据正常展示
        */
        let baseField = getFieldFromGroupData(fields.value, adgroupData.value);
        // let isSame = isSameContent(baseFieldCurrent.value, baseField);

        let isFiledInBatchFormData = props.batchFormData.every(obj =>
          fields.value.every(filed => Object.prototype.hasOwnProperty.call(obj, filed)),
        );
        baseFieldCurrent.value = baseField;
        batchFormCurrent.value = isFiledInBatchFormData ? cloneDeep(props.batchFormData) : changeBatchFormByBase();
      }
    });

    return {
      name,
      modalTitle,
      isEditorEnable,
      baseFieldCurrent,
      batchFormCurrent,
      ageOptions,
      isSelectedIndustryType,
      genderOptions,
      platformOptions,
      networkOptions,
      handleApplyAll,
      handleClose,
      handleApply,
      handleItemValueChange,
      handleBatchItemChange,
    };
  },
});
